const ENDPOINTS = {
  getPermisesList: "premises/premises",
  geSelectedPermiseDetails: "/premise_details",
  getPremiEGPS: "/gps",
  getSalesAgentsLogging: "/api/v1/logging",
  getSalesAgents: "/api/v1/agents",
  login: "/api/shared/login",
  getUsers: "/api/admin/users",
  getRoles: "/api/admin/roles",
  createUser: "/api/admin/users",
  updateUser: "/api/admin/users",
};

export default ENDPOINTS;
